import { Box, Typography, useMediaQuery } from "@mui/material";
import GeoIcon from "@/assets/icons/map/geo.svg?react"
import SignalIcon from "@/assets/icons/map/mobile_signal.svg?react"
import InternetIcon from "@/assets/icons/map/internet.svg?react"
import BatteryLowIcon from "@/assets/icons/map/mobile_battery.svg?react"
import { useMemo } from "react";
import { headerStyles } from "./mockData";

const MobileHeader = () => {
  const isMobile = useMediaQuery("(max-width: 681px)");

  const styles = useMemo(() => isMobile ? headerStyles.xs : headerStyles.md, [isMobile]);

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        boxSizing: "border-box",
        ...styles.container
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center"
        }}
      >
        <Typography
          component="span"
          sx={{
            marginRight: "1px",
            fontWeight: "600",
            ...styles.time
          }}
        >
          11:39
        </Typography>
        <GeoIcon width={isMobile ? "3px" : "8px"} height={isMobile ? "3px" : "8px"} />
      </Box>
      <Box
        sx={{
          display: "flex"
        }}
      >
        <Box
          sx={{
            marginRight: "2px",
            display: "flex",
            alignItems: "center"
          }}
        >
          <SignalIcon width={isMobile ? "5px" : "11px"} height={isMobile ? "3px" : "8px"} />
        </Box>
        <Box
          sx={{
            marginRight: "2px",
            display: "flex",
            alignItems: "center"
          }}
        >
          <InternetIcon width={isMobile ? "4px" : "10px"} height={isMobile ? "3px" : "8px"} />
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center"
          }}
        >
          <BatteryLowIcon width={isMobile ? "7px" : "15px"} height={isMobile ? "3px" : "8px"} />
        </Box>
      </Box>
    </Box>
  )
};

export default MobileHeader;